<template>
  <div class="w-100 h-100 m-0 d-flex flex-column align-items-center" style="padding: 32px 124px;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">カットライン作成代行登録</div>
    </div>
    <div class="d-flex" style="margin:63px 0px; padding:8px 16px;background:#FFF6F6;gap:16px;">
      <img class="m-auto" style="height:30px; width:30px;" src="@/assets/acrypro/attention_icon.svg" />
      <div class="flex-grow-1 text-start">
        <p class="m-0">・こちらのサービスはお手持ちのデザインにカットラインを付け加え、プレート上に仕上げいたします。</p>
        <p class="m-0">・デザイン作成は行っておりません。</p>
        <p class="m-0">・ご依頼は1日1回となり、24時間後に再依頼可能となります。</p>
        <p class="m-0" style="padding-left: 15px;">※SKUが多い場合はお断りさせていただく場合がございます。</p>
        <p class="m-0">・データ送信後はメールでのやり取りになります。</p>
      </div>
    </div>
    <div class="m-0 p-0 d-flex flex-column text-start" style="width:950px;">
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>ご注文サイズ</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 80px;">
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option1" value="S"
              :checked="$store.state.behalfCreate.selectSize === 'S'"
              @change="$store.commit('behalfCreate/set', { key: 'selectSize', value: 'S' })" />
            <div>S</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option2" value="M"
              :checked="$store.state.behalfCreate.selectSize === 'M'"
              @change="$store.commit('behalfCreate/set', { key: 'selectSize', value: 'M' })" />
            <div>M</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option3" value="L"
              :checked="$store.state.behalfCreate.selectSize === 'L'"
              @change="$store.commit('behalfCreate/set', { key: 'selectSize', value: 'L' })" />
            <div>L</div>
          </div>
        </div>
      </div>
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>ご注文内容</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 80px;">
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option1" value="0"
              :checked="$store.state.behalfCreate.selectType === '0'"
              @change="$store.commit('behalfCreate/set', { key: 'selectType', value: '0' })" />
            <div>アクリルキーホルダー</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option2" value="1"
              :checked="$store.state.behalfCreate.selectType === '1'"
              @change="$store.commit('behalfCreate/set', { key: 'selectType', value: '1' })" />
            <div>アクリルスタンド</div>
          </div>
        </div>
      </div>
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>ご注文枚数(予定)</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="height:40px;">
          <div class="m-0 w-100" style="font-size: 15px;">
            <input class="input-form no-spin w-100 h-100" type="number" min="1" max="1000"
              :value="$store.state.behalfCreate.orderNum"
              @input="$store.commit('behalfCreate/set', { key: 'orderNum', value: Number($event.target.value) })"
              @blur="numBlur" style="padding:10px; letter-spacing: 0.75px;" />
          </div>
        </div>
      </div>
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>使用目的</div>
        </div>
        <div class="d-flex flex-grow-1" style="height:40px;">
          <div class="m-0 w-100 h-100" style="font-size: 15px;">
            <input class="input-form no-spin w-100 h-100" type="text"
              :value="$store.state.behalfCreate.usePurpose"
              @input="$store.commit('behalfCreate/set', { key: 'usePurpose', value: $event.target.value })"
              style="padding:10px; letter-spacing: 0.75px;" />
          </div>
        </div>
      </div>
      <div class="cell d-flex" style="gap:30px;">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="">
          <div>見本画像アップロード</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
          <div style="font-size: 12px;">
            <p class="m-0">・弊社にてカットライン作成を行う際に必要になります。</p>
            <p class="m-0">・見本画像を元にデータ作成いたしますので、指示内容を記載してアップロードしてください。</p>
          </div>
          <div class="d-flex flex-column" style="background:#FFF6F6; padding:8px; font-size: 12px; gap:8px;">
            <div class="m-0 d-flex" style="gap:8px;">
              <div class="fw-bold" style="background:#BDBDBD; color:#FFF;">
                Point
              </div>
              <div>
                見本画像について
              </div>
            </div>
            <p class="m-0">・使用したいアタッチメント、希望するカットライン等具体的な内容の指示書がありますとやりとりがスムーズになります</p>
            <img src="@/assets/acrypro/bahelfcreate_sample.png" />
          </div>
          <div style="font-size: 12px;">
            <p class="m-0">【アップロード形式】</p>
            <p class="m-0">
              <span class="mx-1">JPEG</span>
              <span class="mx-1">PNG</span>
              <span class="mx-1">PDF</span>
            </p>
            <p class="m-0">・データ容量100MB以下</p>
          </div>
          <div class="fw-bold" style="font-size: 12px; height:18px;">
            <span v-if="isUploadSampleData">{{$store.state.behalfCreate.sampleData.fileName}}</span>
          </div>
          <label class="uploadlabel position-relative"
            ><input
              type="file"
              ref="sampleData"
              accept=".png,.jpg,.jpeg,.pdf"
              @change="uploadSampleData"
            />
            <div class="d-flex justify-content-center" style="font-size: 16px; letter-spacing: 0.8px; gap:8px;">
              <div style="width:25px; height:25px;">
                <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
                <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
                <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
                </svg>
              </div>
              <div v-if="!isUploadSampleData" class="fw-bold">
                アップロード
              </div>
              <div v-else class="fw-bold">
                再アップロード
              </div>
            </div>
          </label>
        </div>
      </div>
      <div class="cell d-flex" style="gap:44px;">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="">
          <div>データアップロード</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
          <div style="font-size: 12px;">
            <p class="m-0">・サイズは通常注文S、M、Lを参考に作成してください。</p>
          </div>
          <div style="font-size: 12px;">
            <p class="m-0">【アップロード形式】</p>
            <p class="m-0">
              <span class="mx-1">PNG</span>
              <span class="mx-1">AI(Adobe Illustrator)</span>
            </p>
          </div>
          <div class="d-flex flex-wrap" style="gap:16px;">
            <div v-for="(file, key) in $store.state.behalfCreate.imageData" :key="key" class="upload-image-cell d-flex flex-column position-relative">
              <img v-if="isCanViewImage(file.fileName)" class="upload-image" :src="file.fileURL" />
              <div v-else class="upload-image text-start d-flex flex-column justify-content-center">
                 <div class="mx-auto" style="font-size: 12px;">AIデータ</div>
                 <div class="mx-auto" style="font-size: 10px;">※AIデータはプレビューされません</div>
              </div>
              <div style="font-size: 12px;">{{file.fileName}}</div>
              <img src="@/assets/acrypro/upload_cross.svg" class="position-absolute" style="height:16px; width:16px;right: 8px;top: 8px;cursor: pointer;" @click="deleteImage(key)">
            </div>
            <div class="upload-cell">
              <label class="d-flex flex-column align-content-center h-100" style="cursor: pointer;"
                ><input
                  type="file"
                  ref="designData"
                  accept=".png,.ai"
                  @change="uploadDesignData"
                  multiple
                />
                <img class="mx-auto" style="width:82px; height:84px; margin-top:49px;" src="@/assets/acrypro/png_image.png"/>
                <div class="mx-auto fw-bold" style="font-size: 15px; color:#B1C0DB; margin-top:22px;">
                  アップロード
                </div>
              </label>
            </div>

          </div>
        </div>
      </div>
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>指示内容</div>
        </div>
        <div class="d-flex flex-grow-1" style="height:114px;">
          <div class="m-0 w-100 h-100 position-relative" style="font-size: 15px;">
            <textarea class="input-form no-spin w-100 h-100" v-bind:value="remarks" @input="remarks = $event.target.value" style="padding:10px; letter-spacing: 0.75px;" />
            <div v-if="!remarks" class="position-absolute" style="top: 0px; left: 0px; opacity: 0.7; margin: 10px; pointer-events: none;">
              共有したい内容がございましたらご入力ください。<br>
              例<br>
              ・キーホルダー穴…内径3mmを使用して欲しいです。<br>
              ・スタンド…差し込み口10mmを使用して欲しいです。<br>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickSendBtn">
      送信
    </button>
  </div>
</template>

<script>
import axios from 'axios'
import { FileKit } from "@/js/FileKit.js";
import { CenterViewState } from "@/js/Const.js";
import firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/database";
import "firebase/storage";
import config from 'config'
import { Logger } from '@/js/utils/Logger.js';
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import JSZip from "jszip";
import { User } from "@/js/User.js";

export default {
  name: "CenterViewBehalfCreate_Ap",
  props: {},
  data: function () {
    return {
      remarks: "",
    };
  },
  computed: {
    isUploadSampleData() {
      return this.$store.state.behalfCreate.sampleData != null;
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("showLoading");
    this.$store.commit("hideRightMenu");
    this.$store.commit('behalfCreate/reset');
    this.$store.commit("hideLoading");
  },
  components: {
  },
  methods: {
    isCanViewImage(fileName){
      if( fileName.slice(-4) === ".png" ){
        return true;
      }
      return false;
    },
    numBlur(){
      let num = this.$store.state.behalfCreate.orderNum;
      if( isNaN(num) || num < 1 ) num = 1;
      if( num > 1000 ) num = 1000;
      this.$store.commit('behalfCreate/set', { key: 'orderNum', value: num });
    },

    async uploadSampleData() {
      const file = this.$refs.sampleData.files[0];
      if( this.$store.state.behalfCreate.imageData.some(u => u.fileName === file.name) ){
        this.$store.commit("showMessage", "同じ名前のファイルは追加できません");
        return;
      }

      if( file.size > 100000000 ){
        this.$store.commit("showMessage", "データサイズが大きすぎます\n100MB以下にしてください");
        return;
      }
      this.$store.commit('behalfCreate/set', { key: 'sampleData', value: new FileKit(file) })
    },

    async uploadDesignData() {
      for( const file of this.$refs.designData.files ){
        if( this.$store.state.behalfCreate.imageData.some(u => u.fileName === file.name) ||
            this.$store.state.behalfCreate.sampleData?.fileName === file.name ){
          this.$store.commit("showMessage", "同じ名前のファイルは追加できません");
        }else{
          this.$store.commit('behalfCreate/addImageData', new FileKit(file));
        }
      }
    },

    deleteImage(index){
      this.$store.commit('behalfCreate/deleteImageData', index)
    },

    async clickSendBtn(){
      // 必須データのチェック
      if(!this.$store.state.behalfCreate.sampleData){
        this.$store.commit("showMessage", "見本画像がアップロードされていません");
        return;
      }
      if(this.$store.state.behalfCreate.imageData.length < 1){
        this.$store.commit("showMessage", "データがアップロードされていません");
        return;
      }

      this.$store.commit('behalfCreate/set', { key: 'remarks', value: this.remarks })

      this.$store.commit("showLoading");
      Logger.info("作成代行依頼処理の開始");

      // 登録されている住所の取得
      const userInfo = await User.getInfo().catch(() => {
        console.log("エラー");
      });

      Logger.info("データアップロード");
      const uuid = this.generateUUID();
      const zip = new JSZip();
      if( this.$store.state.behalfCreate.sampleData ){
        const downloadUrl = await FirebaseCommon.uploadFile(
          this.$store.state.behalfCreate.sampleData.file,
          FirebaseCommon.getBehalfCreateBaseFilePath()+uuid+"/"+this.$store.state.behalfCreate.sampleData.fileName);
        this.$store.commit('behalfCreate/setSampleDataDownloadUrl', downloadUrl);
        zip.file(this.$store.state.behalfCreate.sampleData.fileName, this.$store.state.behalfCreate.sampleData.file);
      }

      for( let i = 0; i < this.$store.state.behalfCreate.imageData.length; i++ ){
        const imageData = this.$store.state.behalfCreate.imageData[i];
        const downloadUrl = await FirebaseCommon.uploadFile(
          imageData.file,
          FirebaseCommon.getBehalfCreateBaseFilePath()+uuid+"/"+imageData.fileName);
        this.$store.commit('behalfCreate/setImageDataDownloadUrl', { index: i, url: downloadUrl });
        zip.file(imageData.fileName, imageData.file);
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      const zipDownloadUrl = await FirebaseCommon.uploadFile(
          zipBlob,
          FirebaseCommon.getBehalfCreateBaseFilePath()+uuid+"/"+"allFile.zip");

      Logger.info("依頼履歴の登録");
      const orderData = await this.insertBehalfCreateHistory(zipDownloadUrl);

      Logger.info("メール送信");
      const userEmail = firebase.auth().currentUser.email;
      const mailTextForUser = this.mailTextForUser(orderData);
      const mailTextForSystem = this.mailTextForSystem(orderData, userInfo, zipDownloadUrl);

      // データをアップロード
      await this.sendMail(
        {
          data:{
            from: "design@acry.co.jp",
            display: "ACRY PRO",
            to: userEmail,
            subject: "【ACRY PRO】代行作成依頼を受け付けました",
            html: mailTextForUser,
          }
        }
      );

      if(!config.isDebug){
        await this.sendMail(
          {
            data:{
              from: userEmail,
              to: "design@acry.co.jp",
              subject: "【ACRY PRO】代行作成依頼",
              html: mailTextForSystem,
            }
          }
        );
     }

      this.$store.commit("setCenterViewState", CenterViewState.BehalfCreateComplate);
      this.$store.commit("hideLoading");
    },


    async sendMail(param){
      const url = (config.isDebug)?
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail":
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail";

      return axios.post(url, param)
          .then((response) => {
            Logger.debug(response);
          })
          .catch((e) => {
            Logger.error(e);
          });
    },

    generateUUID() {
      const _lut = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff'];
      const d0 = Math.random() * 0xffffffff | 0;
      const d1 = Math.random() * 0xffffffff | 0;
      const d2 = Math.random() * 0xffffffff | 0;
      const d3 = Math.random() * 0xffffffff | 0;
      const uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff]; // .toLowerCase() here flattens concatenated strings to save heap memory space.

      return uuid.toLowerCase();
    },

    async insertBehalfCreateHistory(zipDownloadUrl)
    {
      const data = {
        "createAt":new Date(),
        "uid":firebase.auth().currentUser.uid,
        "orderType":(this.$store.state.behalfCreate.selectType=="0")?"アクリルキーホルダー":"アクリルスタンド",
        "orderNum":this.$store.state.behalfCreate.orderNum,
        "selectSize":this.$store.state.behalfCreate.selectSize,
        "usePurpose":this.$store.state.behalfCreate.usePurpose,
        "remarks":this.$store.state.behalfCreate.remarks,
        "zipDownloadUrl" : zipDownloadUrl,
      };

      if( this.$store.state.behalfCreate.sampleData ){
        data.sampleData = this.$store.state.behalfCreate.sampleData.downloadUrl;
      }

      data.imageData = [];
      for( const imageData of this.$store.state.behalfCreate.imageData ){
        data.imageData.push(imageData.downloadUrl)
      }

      await firebase.firestore().collection("AcryProBehalfCreateHistory").add(data);
      return data;
    },

    mailTextForUser(orderData){
      const siteUrl = (config.isDebug)?"https://testpro.acry.co.jp":"https://pro.acry.co.jp";

      return `
      代行作成依頼を受け付けました<br>
      <br>
      <br>
      【受け付け日時】<br>
      ${this.formatDate(new Date(orderData.createAt))} <br>
      <br>
      【ご注文サイズ】<br>
      ${orderData.selectSize}<br>
      <br>
      【ご注文内容】<br>
      ${orderData.orderType}<br>
      <br>
      【ご注文枚数】<br>
      ${orderData.orderNum} <br>
      <br>
      【使用目的】<br>
      ${orderData.usePurpose} <br>
      <br>
      【備考】<br>
      ${orderData.remarks} <br>
      <br>
      <br>
      ACRY PRO<br>
      ${siteUrl}<br>
      `;
    },

    mailTextForSystem(orderData, userInfo, zipDownloadUrl){
      return `
      AcryPro作成代行依頼<br>
      <br>
      <br>
      【受け付け日時】<br>
      ${this.formatDate(new Date(orderData.createAt))} <br>
      <br>
      【お名前】<br>
      ${userInfo.name01 + userInfo.name02}<br>
      <br>
      【会社名・屋号】<br>
      ${userInfo.company_name}<br>
      <br>
      【ご注文サイズ】<br>
      ${orderData.selectSize}<br>
      <br>
      【ご注文内容】<br>
      ${orderData.orderType}<br>
      <br>
      【ご注文枚数】<br>
      ${orderData.orderNum} <br>
      <br>
      【使用目的】<br>
      ${orderData.usePurpose} <br>
      <br>
      【備考】<br>
      ${orderData.remarks} <br>
      <br>
      【見本画像】<br>
      ${(this.$store.state.behalfCreate.sampleData)?this.$store.state.behalfCreate.sampleData.fileName:""} <br>
      <br>
      【データ】<br>
      ${this.$store.state.behalfCreate.imageData.map(d => d.fileName ?? '').join(' ')} <br>
      <br>
      【ファイル一覧】<br>
      ${zipDownloadUrl} <br>
      `;
    },

    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cell{
  gap: 64px;
  padding-top: 24px;
  padding-bottom: 32px;
  border-bottom: solid 1px $border-sub-color;
  &:last-child { border-bottom: none; } // 最終行だけいらない
}

.fill-color {
  fill: $primary-main-color;
  margin-top: -6px;
  // position: absolute;
  // left: 51px;
  // top: 6px;
}

.input-required{
  width: 48px;
  height: 24px;
  background: $status-error-color;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 13px;
}

.input-radio{
  width: 24px;
  height: 24px;
  accent-color: #8593bc;
}

.input-form{
  border-radius: 4px;
  border: solid 1px $border-gray001-color;
}

.uploadlabel {
  margin: 8px;
  padding: 6px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

input[type="file"] {
  display: none;
}

.upload-image-cell{
  width: 170px;
  height: 251px;
  gap: 8px;
}

.upload-cell{
  width: 170px;
  height: 251px;
  border: 1px dashed $primary-hover-color;
  background: $background-gray-color;
}

.upload-image{
  object-fit: contain;
  border: solid 1px $text-sub-color;
  width: 170px;
  height: 227px;
}

</style>


